exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagetitle_error[data-v-a11fe73a]{font-size:12px;font-weight:400;color:#F5212D;padding-top:5px}\n", ""]);

// exports
